export const AUTH_UNAUTHORIZED_EVENT = "auth:unauthorized";

export const emitUnauthorizedLogout = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT));
};

